import { ApplicationSettingApi } from '../models/application-setting-api.model'
import { ApplicationSettingConfig } from '../models/application-settings-item.model'
import { Injectable } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class ApplicationSettingsMappingService {
  mapApplicationSettingsToApi = (settings: ApplicationSettingConfig[]): ApplicationSettingApi[] =>
    settings.map((setting) => this.mapApplicationSettingToApi(setting))

  mapApplicationSettingToApi = (setting: ApplicationSettingConfig): ApplicationSettingApi => ({
    id: setting.id,
    applicationSettingType: setting.setting,
    isEnabled: setting.isEnabled,
    isEditEnabled: setting.isEditEnabled,
  })
}
